import { render } from "./Types.vue?vue&type=template&id=06ab1403&scoped=true&ts=true"
import script from "./Types.vue?vue&type=script&lang=ts"
export * from "./Types.vue?vue&type=script&lang=ts"

import "./Types.vue?vue&type=style&index=0&id=06ab1403&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ab1403"]])

export default __exports__